import { useMemo } from 'react';

function OfflineLessonRow({ lesson, onRemove, removing }) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-[#E8E8E8] bg-[#FAFAFA] px-4 py-3">
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-[#1B1B1B]">{lesson.title}</p>
        {lesson.duration != null ? (
          <p className="mt-0.5 text-xs text-[#666666]">{lesson.duration} min</p>
        ) : null}
      </div>
      <button
        type="button"
        disabled={removing}
        onClick={() => onRemove(lesson.id)}
        className="shrink-0 rounded-full border border-[#D9D9D9] px-3 py-1.5 text-xs font-semibold text-[#666666] transition hover:border-[#E53935] hover:text-[#E53935] disabled:cursor-not-allowed disabled:opacity-50"
      >
        Remove
      </button>
    </div>
  );
}

export default function OfflineDownloadsPanel({
  offlineVideos = [],
  loading = false,
  actionLoading = false,
  error = null,
  onRemoveLesson,
  onRemoveAll,
}) {
  const downloadedLessons = useMemo(
    () => offlineVideos.flatMap((chapter) => chapter.lessons || []),
    [offlineVideos]
  );

  if (loading && !downloadedLessons.length) {
    return (
      <section className="mt-8 rounded-2xl border border-[#E8E8E8] bg-white p-5 shadow-sm">
        <div className="h-5 w-40 animate-pulse rounded bg-gray-200" />
        <div className="mt-4 space-y-3">
          <div className="h-14 animate-pulse rounded-xl bg-gray-100" />
          <div className="h-14 animate-pulse rounded-xl bg-gray-100" />
        </div>
      </section>
    );
  }

  if (!downloadedLessons.length) return null;

  return (
    <section className="mt-8 rounded-2xl border border-[#E8E8E8] bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-[#1B1B1B]">Offline Downloads</h2>
          <p className="mt-1 text-sm text-[#666666]">
            {downloadedLessons.length} lesson{downloadedLessons.length === 1 ? '' : 's'} saved for offline viewing.
          </p>
        </div>
        {onRemoveAll ? (
          <button
            type="button"
            disabled={actionLoading}
            onClick={onRemoveAll}
            className="rounded-full border border-[#D9D9D9] px-4 py-2 text-xs font-semibold text-[#666666] transition hover:border-[#E53935] hover:text-[#E53935] disabled:cursor-not-allowed disabled:opacity-50"
          >
            Remove all
          </button>
        ) : null}
      </div>

      {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}

      <div className="mt-4 space-y-3">
        {downloadedLessons.map((lesson) => (
          <OfflineLessonRow
            key={lesson.id}
            lesson={lesson}
            removing={actionLoading}
            onRemove={onRemoveLesson}
          />
        ))}
      </div>
    </section>
  );
}
